export const BULK_MAX_CONTENTS = 100;
export const BULK_CONTENT_ID_PATTERN = /^[A-Za-z0-9_-]+$/;

export const isValidBulkContentID = (contentID) =>
  BULK_CONTENT_ID_PATTERN.test(String(contentID ?? ""));

export const toBulkContentIDs = (contents = []) =>
  (Array.isArray(contents) ? contents : [])
    .map((item) =>
      item && typeof item === "object" ? item.contentID || item.id : item
    )
    .map((contentID) => String(contentID ?? ""))
    .filter((contentID) => BULK_CONTENT_ID_PATTERN.test(contentID))
    .slice(0, BULK_MAX_CONTENTS);
